import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import './style.scss';
import { Path } from 'router/constant';

export const GithubLink: React.FC = () => {
  const state = uuidv4();
  localStorage.setItem('github_installation_state', state);

  const handleRedirect = () => {
    const appName = process.env.REACT_APP_GITHUB_APP_NAME;
    const baseReliantUrl = process.env.REACT_APP_BASE_RELIANT_URL;

    window.open(
      `https://github.com/apps/${appName}/installations/new?state=${state}&redirect_uri=${baseReliantUrl}${Path.GITHUB_INSTALLATION}`,
      '_blank',
    );
  };

  return (
    <div className="github-link-container">
      <div
        onClick={handleRedirect}
        className="github-link-button mt-10 w-fit logout_popup flex justify-center gap-3 cursor-pointer">
        Install Github App
      </div>
    </div>
  );
};
